import fileDownload from 'js-file-download';

// Receives a base64 string, creates a blob out of it and downloads the file
const downloadXML = (base64, filename) =>
  fetch(`data:text/xml;base64,${base64}`)
    .then((res) => res.blob())
    .then((blob) => fileDownload(blob, `${filename}`));

export default downloadXML;
